import React from "react";
import { Route, Switch } from "react-router-dom";

import { PORTALTHIRD_BASE_URL } from "../../constants/constants";
import { DlpFlowStepFive } from "../../layouts/dlpFlow/DlpFlowStepFive";
import { DlpFlowStepFour } from "../../layouts/dlpFlow/DlpFlowStepFour";
import { DlpFlowStepOne } from "../../layouts/dlpFlow/DlpFlowStepOne";
import { DlpFlowStepThree } from "../../layouts/dlpFlow/DlpFlowStepThree";
import { DlpFlowStepTwo } from "../../layouts/dlpFlow/DlpFlowStepTwo";

const DlpFlow = (props) => (
  <Switch>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step1Path.value}`}>
      <DlpFlowStepOne {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step2Path.value}`}>
      <DlpFlowStepTwo {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step3Path.value}`}>
      <DlpFlowStepThree {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step4Path.value}`}>
      <DlpFlowStepFour {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step5Path.value}`}>
      <DlpFlowStepFive {...props} />
    </Route>
  </Switch>
);

export default DlpFlow;
